import React from 'react';

import ActivityDropdown from '../../base/dropdowns/activity-dropdown';

const StrategiesDropdown = ({ strategyOptions, filterBy, setFilterBy }) => {
  return (
    <div className="strategies-dropdown">
      <ActivityDropdown
        items={strategyOptions}
        selectItem={idx => setFilterBy(strategyOptions[idx])}
        dropdownLabel={filterBy.label}
        initialSelection={strategyOptions.findIndex(item => item.label === filterBy.label)}
      />
    </div>
  );
};

export default StrategiesDropdown;
